/*
 * File: PublicRouteWrapper.jsx
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on June 13, 2024 at 10:03 AM
 * Copyright © 2024 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: April 1, 2025 at 2:19 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';


/**
 * Route Wrapper
 */

export const PublicRouteWrapper = ({
	children, requireAuth
}) => {

	// Get current user
	const user = useSelector((state) => state.user.value);

	// Get current locale from hook
	const locale = useSelector((state) => state.locale.value);

	// Handle auth actions if requires auth
	if (requireAuth === true) {

		// Check user state
		if (!user) {

			// Redirect to login
			return <Navigate to={`${locale.localePath}/login`} />;
		}
		if (user.is_anonymous === true) {

			// Redirect to login
			return <Navigate to={`${locale.localePath}/login`} />;
		}
		if (user.is_active !== true) {

			// Redirect to logout
			window.location = '/logout';
			return null;
		}
	}

	// Return children
	return children;
};


/**
 * Configuration
 */

PublicRouteWrapper.propTypes = {
	children: PropTypes.element,
	requireAuth: PropTypes.bool
};
PublicRouteWrapper.defaultProps = {
	children: null,
	requireAuth: false
};
